/* global System */
// register component(s) with react habitat

export default { ChooseStage: () => System.import('./index') }
